import { InvoiceStatus } from "@common/types/invoice";

export enum InvoiceScheduleBlockReason {
    draft = "draft",
    void = "void",
    uncollectable = "uncollectable",
    notPosted = "notPosted",
    nonUsd = "nonUsd",
}

const STATUS_BLOCK_REASONS: Record<
    InvoiceStatus,
    InvoiceScheduleBlockReason | null
> = {
    [InvoiceStatus.OPEN]: null,
    [InvoiceStatus.PAID]: null,
    [InvoiceStatus.DRAFT]: InvoiceScheduleBlockReason.draft,
    [InvoiceStatus.VOID]: InvoiceScheduleBlockReason.void,
    [InvoiceStatus.UNCOLLECTABLE]: InvoiceScheduleBlockReason.uncollectable,
};

export const INVOICE_SCHEDULE_BLOCK_MESSAGES: Record<
    InvoiceScheduleBlockReason,
    string
> = {
    [InvoiceScheduleBlockReason.draft]:
        "Recognition schedules cannot be applied to draft invoices",
    [InvoiceScheduleBlockReason.void]:
        "Recognition schedules cannot be applied to void invoices",
    [InvoiceScheduleBlockReason.uncollectable]:
        "Recognition schedules cannot be applied to uncollectible invoices",
    [InvoiceScheduleBlockReason.notPosted]:
        "Only posted USD invoices can be scheduled",
    [InvoiceScheduleBlockReason.nonUsd]:
        "Only posted USD invoices can be scheduled",
};

export function getInvoiceScheduleBlockReason(invoice: {
    status: InvoiceStatus;
    currency: string;
}): InvoiceScheduleBlockReason | null {
    const statusReason = STATUS_BLOCK_REASONS[invoice.status];
    if (statusReason) {
        return statusReason;
    }
    if (invoice.currency.toLowerCase() !== "usd") {
        return InvoiceScheduleBlockReason.nonUsd;
    }
    return null;
}

export const INVOICE_SCHEDULE_LINE_MISMATCH_MESSAGE =
    "Selected invoice lines do not belong to the invoice";

export function getInvoiceScheduleBlockMessage(invoice: {
    status: InvoiceStatus;
    currency: string;
}): string | null {
    const blockReason = getInvoiceScheduleBlockReason(invoice);
    return blockReason ? INVOICE_SCHEDULE_BLOCK_MESSAGES[blockReason] : null;
}
